import hourMinuteString from '../hourMinuteString';

const minutesToDurationString = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hourMinuteString(hours, minutes);
};

export default minutesToDurationString;
